import { FETCH_USER } from '../actions/types.js';

export default (state = null ,action) => {
	switch (action.type) {
		case ( FETCH_USER ):
			return action.payload || false;
			break; // eslint-disable-line no-unreachable
		default:
			return state;
		break; // eslint-disable-line no-unreachable
	}
}


// WEBPACK FOOTER //
// ./src/reducers/authReducer.js